import { isEqual } from 'lodash'
import { getConfigableColumns, getUnconfigableColumns, filterOperator, filterForExport, getColumnName } from 'tyan/public/components/column'

/**
 * 读取Manager页面的配置
 * @param {*} component 组件本身
 * @returns 
 */
const getConfigs = component => {
	// if (!(component = Tyan.menuComponents[component]))
	if (!component)
		return undefined

	let comp = null
	try {
		comp = new component
		if (!comp.type.name.includes('Manage'))
			comp = new comp.type(comp.props)
	} catch (e) {
		comp = null
	}

	// console.log('debug:', component, comp, !!comp?.props?.config)
	return comp?.props?.config
}

/**
 * 判断是否为Manager组件
 * @param {*} component 组件本身
 * @returns 
 */
export const isManager = component => {
	return !!getConfigs(component)
}

/**
 * 读取默认配置
 * @param {*} component 组件本身
 * @returns 
 */
export const getDefaultConfigs = component => {
	let configs = getConfigs(component)
	// console.log('config:', config)
	if (!configs) return undefined

	configs = typeof configs == 'function' ? configs({ roles: Tyan.loginInfo?.roles || [] }) : configs
	configs = configs.tabs ? configs : { tabs: { '': configs } }

	return Object.entries(configs.tabs).reduce((sum, [n, { columns, ['export']: exp, exportColumns, pivot }]) => {
		columns = filterOperator(columns)
		const tabConfig = sum[n] = { columns, ['export']: exp, pivot }
		tabConfig.export == true && exportColumns && (tabConfig.export = exportColumns)
		return sum
	}, {})
}

const levelSpace = 2
/**
* 组织列项组的呈现形式，以每一个列项为一行
* @param {*} cols 列项组
* @param {*} level 前置空格数
* @returns 
*/
export const genColumnsValue = (cols, level = 0) => {
	const colsValue = cols?.map(col => `${' '.repeat((level + 1) * levelSpace)}${JSON.stringify(col, undefined, 2)
		.replaceAll(',\n  ', ', ').replace('\n  ', '').replace('\n}', '}')}`)
		.join(',\n')
	return colsValue ? `[\n${colsValue}\n${' '.repeat(level * levelSpace)}]` : ''
}
/**
 * 组织导出配置的呈现形式
 * @param {*} exp 
 * @param {*} exportColumns 
 * @param {*} level 
 */
export const genExportValue = (exp, exportColumns, level = 0) => {
	// 支持旧的配置的exportColumns
	exp = exp || exportColumns
	return exp
		? typeof exp == 'string'
			? `"${exp}"`
			: Array.isArray(exp)
				? genColumnsValue(exp, level)
				: exp == true
					? 'true'
					: '{\n'
					+ `${Object.entries(exp).map(([n, v]) => (
						`${' '.repeat((level + 1) * levelSpace)}"${n}": `
						// + `${genColumnsValue(v, level + 1)}`))
						+ `${genExportValue(v, undefined, level + 1)}`))
						.join(',\n')}\n`
					+ `${' '.repeat(level * levelSpace)}}`
		: ''
}

/**
 * 组织pivot配置的呈现形式
 * @param {*} pivot 
 * @param {*} level 
 * @returns 
 */
export const genPivotValue = (pivot, level = 0) => {
	return JSON.stringify(pivot, undefined, 2) || ''
}

/**
 * 根据自定义配置重新组织managerConfigs中各个tab的columns, export, pivot，仅用于ManagerInner最后组织configs使用
 * 最后组织出来的export和pivot均为对象模式
 * @param {*} component // 组件名称或组件本身
 * @param {*} configs 	// 当前使用配置
 * @param {*} managerConfigs // 自定义配置
 * @returns 
 */
export const mergeConfigs = (component, configs, managerConfigs = {}) => {
	// 首先复制configs，不能破坏系统配置中的config
	configs = { ...configs }
	for (const tab in configs) {
		const config = configs[tab] = { ...configs[tab] }
		if (typeof config.disabled == 'function' ? config.disabled() : config.disabled) {
			delete configs[tab]
			continue
		}
		['export', 'exportColumns', 'pivot', 'show'].forEach(item => {
			config[item] !== undefined && (config[item] = typeof config[item] == 'function' ? config[item]() : config[item])
		})
	}

	// 处理configs中的导出配置
	Object.values(configs).forEach(config => {
		config.export == true && (config.export = { '': config.exportColumns || config.columns })
		delete config.exportColumns
	})

	// 整合managerConfig到configs中
	if (Object.keys(managerConfigs).length) {
		const defaultConfigs = getDefaultConfigs(component)

		// console.log('managerConfig:', managerConfig)
		// console.log('defaultConfig', defaultConfig)
		// console.log('configs', configs)

		// 根据managerConfig(自定义配置)中的tab开始处理
		Object.entries(managerConfigs).forEach(([tab, managerConfig]) => {
			// 处理managerConfig中的导出配置
			// 首先判断配置是否一致，如果一致则跳
			const config = configs[tab]
			if (!config || isEqual(managerConfig, defaultConfigs[tab]))
				return

			let { columns: managerColumns, export: managerExport, exportColumns: managerExportColumns, pivot: managerPivot } = managerConfig
			managerExport = managerExport !== undefined ? managerExport : managerExportColumns

			const configColumns = config.columns
			// 处理columns
			if (managerColumns && !isEqual(managerColumns, defaultConfigs[tab].columns)) {
				// 根据名称恢复默认属性
				// 组织名称map
				const colsMap = getConfigableColumns(configColumns).reduce((sum, col) => (sum[getColumnName(col)] = col, sum), {})
				config.columns = managerColumns
					.map(col => ({ ...colsMap[getColumnName(col)] || {}, ...col }))
					.concat(getUnconfigableColumns(configColumns))
			}

			// 合并export
			if (managerExport !== undefined) config.export = managerExport

			// 合并pivot
			if (managerPivot !== undefined) config.pivot = managerPivot
		})
	}

	// 重新组织configs中的export, pivot
	Object.values(configs).forEach(config => {
		// 处理export
		if (config.export !== undefined) {
			config.export == true && (config.export = config.columns)
			true && (Array.isArray(config.export) || typeof config.export == 'string') && (config.export = { '': config.export })
			// 在config.export为对象时判断是合法的多export配置还是有columns或exportEvent单个配置
			true && (config.export?.cdt != undefined || config.export?.columns || config.export?.exportEvent) && (config.export = { '': config.export })
			// 逐个处理confi.export中的对象
			Object.entries(config.export || {}).forEach(([n, exp]) => {
				if (exp == false)	// 配置为false
					delete config.export[n]
				if (exp == true)	// 配置为true
					config.export[n] = { columns: config.columns }
				else if (Array.isArray(exp))	// 配置为数组，则为columns
					config.export[n] = { columns: exp }
				else if (typeof exp == 'string')		// 配置为一个字符串，则为exportEvent
					config.export[n] = { exportEvent: exp }
				else if (typeof exp != 'object')	// 配置不是对象，则为错误，删除
					config.error(`导出配置 '${n}' 错误: '${exp}'`), delete config.export[n]
				else if (exp.cdt != undefined) {// 有cdt则计算cdt值(不为字符串则直接判断，是字符串则尝试为代码执行判断)
					if (typeof exp.cdt == 'string')
						try {
							// console.log('exp.cdt:', `'${exp.cdt}'`)
							!eval(exp.cdt) && delete config.export[n]
						} catch (e) {
							console.error(`导出配置 '${n}' 条件表达式错误: '${exp.cdt}'`)
							delete config.export[n]
						}
					else if (typeof exp.cdt == 'function' ? !exp.cdt({ roles: Tyan?.loginInfo?.roles }) : !exp.cdt)
						delete config.export[n]
					config.export[n] && (!config.export[n].columns && !config.export[n].exportEvent) && (config.export[n].columns = config.columns)
					delete config.export?.[n]?.cdt
				}

			})
			!Object.entries(config.export || {}).length && (delete config.export)
		}

		// 处理pivot
		config.pivot == true && (config.pivot = {})
		config.pivot && !config.pivot.views && (config.pivot = { views: { '': config.pivot } })
	})

	return configs
}

/**
 * 将pathName转换为componentName：去除起头的/，并将所有/转移为_
 * @param {*} pathName 
 * @returns 
 */
export const pathNameToComponentName = pathName => (pathName = (pathName || '').trim(), pathName.startsWith('/') ? pathName.substring(1) : pathName).replaceAll('/', '_')